import axios from 'axios'
import { Modal } from 'bootstrap'
import swal from 'sweetalert'

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
const modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {

    // Backdrop.
    const backdrop = document.createElement('div')
    backdrop.classList.add('modal-backdrop', 'fade', 'show')
    document.querySelector('#app-panel').appendChild(backdrop)
  })

  // Remove the modal backdrop on modal close.
  modal.addEventListener('hidden.bs.modal', e => {
    const backdrop = document.querySelector('.modal-backdrop')
    backdrop.parentNode.removeChild(backdrop)
  })
})

// Look for links that target modals...
const modalLinks = document.querySelectorAll('a[href^="#"]')
modalLinks.forEach(modalLink => {
  modalLink.addEventListener('click', (e) => {
    e.preventDefault()

    const href = modalLink.getAttribute('href')
    if (href && href != '#') {

      const target = document.querySelector(href)
      if (target && target.classList.contains('modal')) {
        const modal = Modal.getOrCreateInstance(target)
        modal.show()
      }
    }
  })
})
